import { render, staticRenderFns } from "./LenderCorporate.vue?vue&type=template&id=0fb5d008&scoped=true&"
import script from "./LenderCorporate.vue?vue&type=script&lang=js&"
export * from "./LenderCorporate.vue?vue&type=script&lang=js&"
import style0 from "./LenderCorporate.vue?vue&type=style&index=0&id=0fb5d008&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb5d008",
  null
  
)

export default component.exports